import { defineComponent } from 'vue';
import StockistAccordion from './StockistAccordion';

export default defineComponent({
  delimiters: ['${', '}'],
  components: {
    StockistAccordion,
  },
  computed: {
    stockists() {
      return this.$store.getters.filteredStockists ?? this.$store.getters.stockists;
    },
  },
  methods: {
    /**
     * Change the center of the map based to the marker "position"
     * of a stockist using the index of the stockist in stockists
     */
    setMapCenter(id: number) {
      this.$store.commit('setMapCenter', id);
      this.$store.commit('setMapZoom', 14);
    },
  },
  template: '#t-stockist-list',
});
